export default __webpack_public_path__ + "static/gracie-sunday-273a302fb395858a32f6aa520486b2b1.png";